import { gql } from '@apollo/client';

export const FEED_LIKE = gql`
  mutation FeedLike($feedType:String,$id:Int,$personId:Int) {
    feedLike(feedType:$feedType,id:$id,personId:$personId)
  }
`;

export const DELETE_COMMENT = gql`
  mutation DeleteComment($commentId:Int,$eventId:Int) {
    deleteComment(commentId:$commentId,eventId:$eventId)
  }
`;

export const UPDATE_COMMENT = gql`
  mutation UpdateComment($comment:String,$commentId:Int,$eventId:Int) {
    updateComment(commentId:$commentId,eventId:$eventId,comment:$comment,)
  }
`;

export const CREATE_COMMENT = gql`
  mutation CreateComment($comment:CommentInput) {
    createComment(comment:$comment)
  }
`;

export const REPORT_COMMENT = gql`
  mutation ReportComment($report:ReportInput) {
    reportComment(report:$report)
  }
`;
